import React from 'react';
import Head from 'next/head';

import { useUrlUtils } from 'src/common/hooks/useUrlUtils';
import { AssetType } from 'src/components/GlintsPicture/interfaces';

export const GoogleLogoSchema: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { getOpenGraphURL } = useUrlUtils();
  const logoUrl = getOpenGraphURL('favicon.png', AssetType.dst);
  const googleLogoSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: 'https://glints.com/',
    logo: `${logoUrl}`,
  };

  return (
    <Head>
      <script
        key="google-logo-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `${JSON.stringify(googleLogoSchema)}`,
        }}
      />
    </Head>
  );
};
